import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

const SalaryAdjustmentModal = ({ open, onOpenChange, employee, adjustmentType, onSubmit }) => {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [reason, setReason] = useState('');

  const typeLabels = {
    prime: 'Ajouter une prime / indemnité',
    avance: 'Ajouter une avance sur salaire',
    retenue: 'Ajouter une retenue'
  };

  const typeColors = {
    prime: 'text-green-700',
    avance: 'text-blue-700',
    retenue: 'text-red-700'
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({
        employee_id: employee?.id,
        type: adjustmentType,
        amount: parseFloat(amount),
        date,
        reason
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className={typeColors[adjustmentType] || ''}>
            {typeLabels[adjustmentType]}
          </DialogTitle>
          <DialogDescription className="sr-only">Modal pour les ajustements de salaire</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Date</label>
            <Input 
              type="date" 
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Montant (DZD)</label>
            <Input 
              type="number" 
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="col-span-3"
              placeholder="0.00"
              min="0"
              step="0.01"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Motif</label>
            <Input 
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Ex: Prime de rendement, retard..."
              className="col-span-3"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={handleSubmit} className="bg-violet-600 hover:bg-violet-700 text-white">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SalaryAdjustmentModal;
